<template>
    <page-template page-id="Consent" ref="super">

        <document-title :title="$tb('pages.consentData.documentTitle')"></document-title>

        <template v-slot:before v-if="isTitlebarActive">
            <titlebar :text="$t('pages.consentData.title')"></titlebar>
        </template>

        <div class="ui column">

            <h4 class="custom-ui header" v-text="$t('pages.consentData.header')"></h4>
            <p v-html="$tb('pages.consentData.subheader', {
                0: escapeHtml($store.state.appName),
                1: userOrCompanyName
            })"></p>

            <messages id="Notifications" ref="postman"></messages>

            <div class="ui grid scopes" v-if="grantedScopes">
                <div class="scope row" v-for="(scope, name) in translatedScopes" :key="name">

                    <div class="left floated left aligned ten wide column">
                        <div class="ui toggle checkbox">
                            <input type="checkbox" :id="'scope_' + name" :name="'scope_' + name"
                                   v-model="grantedScopes[name]" />
                            <label :for="'scope_' + name" class="scope-name">{{ scope.displayName }}</label>
                        </div>
                    </div>

                    <div class="right floated right aligned two wide column">
                        <i v-if="scope.description" tabindex="0" class="big blue info circle icon popup" :data-content="scope.description"
                           :aria-label="scope.description"></i>
                    </div>

                </div>
            </div>

            <div>
                <p id="consent-button-info"
                   v-html="$t('pages.consentData.allowInfo', {allowButton: $t('pages.consentData.allowButton')})"></p>
                <p id="consent-purpose-link" v-if="consentPurposeLink != null"
                   v-html="$t('pages.consentData.purposeInfo', {0: buildLink($t('pages.consentData.purposeLinkText'))})"></p>
            </div>

            <div class="field">
                <button id="allow" type="button" v-on:click="onContinue"
                        class="ui fluid large primary submit button" aria-describedby="consent-button-info">
                    {{$t('pages.consentData.allowButton')}}
                </button>
            </div>
        </div>

    </page-template>
</template>

<script>
import PageTemplate from './template/PageTemplate.vue'
import Titlebar from '../components/Titlebar.vue'
import Messages from '../components/Messages.vue'
import DocumentTitle from '../components/DocumentTitle.vue'
import { mixin } from '../js/ciam-mixin.js'
import { brand } from '../js/brand.js'
import Vue from 'vue'

function defaultIfEmpty (x, defVal) {
  return x != null && x.length > 0 ? x : defVal
}

function buildGrantedScopes (requestedScopes, defaultScopes) {
  const scopesToBeConsented = defaultIfEmpty(requestedScopes, defaultScopes)
  const grantedScopes = {}
  scopesToBeConsented.forEach(scope => {
    grantedScopes[scope] = false
  })
  return grantedScopes
}

export default {
  components: { Messages, PageTemplate, Titlebar, DocumentTitle },
  mixins: [mixin, brand],
  props: {
    requestedScopes: {
      type: Array,
      default: function () {
        return []
      }
    },
    consentPurposeLink: {
      type: String,
      default: 'https://www.daimler.com' // test data
    }
  },
  data: function () {
    return {
      grantedScopes: buildGrantedScopes(this.requestedScopes, this.$store.state.newScopes),
      translatedScopes: {
        type: Object,
        default: { // test
          test: {
            description: 'This is only <b>test</b> data',
            displayName: 'Test scope'
          },
          open_car: {
            description: 'opens your car like a can',
            displayName: 'Open Car'
          }
        }
      }
    }
  },
  methods: {
    init: function () {
      if (this.hasGrantedScopes) {
        this.$refs.super.startLoading()
        this.loadScopeTranslations(this.$store.state.lang)
      }
    },
    hasGrantedScopes: function () {
      return this.grantedScopes != null && Object.keys(this.grantedScopes).length > 0
    },
    loadScopeTranslations: function (language) {
      const keys = Object.keys(this.grantedScopes)
      console.info(`Loading scope translations [language=${language}, scopes=${this.grantedScopes}]`)
      this.$api.translation.loadConsentTranslations(language, keys.join(' '), this.setTranslations, this.onFail)
    },
    onContinue: function (e) {
      if (jQuery('form#consent').form('is valid')) {
        this.$refs.super.startLoading()

        this.saveConsent()
        if (e) e.preventDefault()
      } else {
        console.debug('validation failed')
      }
      return false
    },
    saveConsent: function () {
      const scopes = this.grantedScopes
      const filteredGrantedScopes = Object.keys(this.translatedScopes).filter(function (e) {
        return scopes[e]
      })

      const payload = this.$api.payloads.buildSaveConsentPayload(filteredGrantedScopes)
      this.$api.login.saveConsent(payload, this.handleRoutingResponse, this.onFail)
    },
    onFail: function (response) {
      this.onAjaxError(response)
      this.$refs.super.stopLoading()
    },
    buildLink: function (text) {
      const link = this.consentPurposeLink
      return '<a id="consentLink" href="' + link + '" target="_blank">' + text + '</a>'
    },
    setTranslations: function (resp) {
      console.log(resp)
      this.translatedScopes = this.sortTranslatedScopes(resp)
      this.$refs.super.stopLoading()
      Vue.nextTick(this.initPopups)
    },
    sortByTranslation: function (scopes) {
      const localScopes = scopes
      localScopes.sort(function (scopeA, scopeB) {
        const scopeDisplayNameA = scopeA.displayName ? scopeA.displayName.toUpperCase() : scopeA.key
        const scopeDisplayNameB = scopeB.displayName ? scopeB.displayName.toUpperCase() : scopeB.key
        return scopeDisplayNameA.localeCompare(scopeDisplayNameB)
      })
      return localScopes
    },
    sortTranslatedScopes: function (resp) {
      const result = {}
      const scopes = []
      Object.keys(resp).forEach(function (key) {
        const scope = resp[key]
        scope.key = key
        scopes.push(scope)
      })
      const sortedScopes = this.sortByTranslation(scopes)
      sortedScopes.forEach((scope) => {
        const key = scope.key
        result[key] = resp[key]
      })
      return result
    },
    initPopups: function () {
      $('.popup')
        .popup({
          namespace: 'onhoverpopup',
          hoverable: true,
          delay: {
            show: 300,
            hide: 300
          },
          position: 'top center',
          on: 'hover'
        })
        .popup({
          namespace: 'onfocuspopup',
          hoverable: true,
          delay: {
            show: 300,
            hide: 300
          },
          position: 'top center',
          on: 'focus'
        })
    }
  },
  computed: {
    userOrCompanyName: function () {
      return this.$store.state.companyName ? this.$store.state.companyName : this.$store.state.username
    }
  },
  mounted: function () {
    console.info(`Consent scopes [username=${this.$store.state.username}, scopes=${this.requestedScopes}, consentPurposeLink=${this.consentPurposeLink}]`)

    this.init()
  }
}
</script>

<style scoped>
    .scope.row .right.floated.right.aligned.two.wide.column {
        padding: 0 0.5rem;
    }

    .ui.grid.scopes {
        margin: 0 0 20px -14px;
    }

    .ui.grid > .scope.row .column {
        margin-top: 5px;
    }
    .scope .ui.toggle.checkbox {
        margin: 5px 0 0;
    }

    .scope .ui.toggle.checkbox label {
        font-family: DaimlerCS-Regular, sans-serif;
        font-weight: 700;
        font-size: 20px
    }

    @media only screen and (max-width:600px){
      .scope-name {
        width:220px;
      }
    }
</style>
